type FullStorySnippet = (operation: string, options: unknown) => void;

/** The FullStory snippet Google Tag Manager puts on the page, once it has. */
const snippet = (): FullStorySnippet | undefined => {
	const page = window as unknown as Record<string, unknown>;
	const fs = page[(page._fs_namespace as string | undefined) ?? 'FS'];
	return typeof fs === 'function' ? (fs as FullStorySnippet) : undefined;
};

const POLL_MS = 500;
const WAIT_MS = 10_000;

/**
 * Sends a custom event to FullStory. Google Tag Manager loads FullStory, not
 * `@fullstory/browser` (whose API sends nothing until its own `init` runs, which
 * it never does here), so this calls the snippet GTM puts on the page. The snippet
 * is never there during server rendering and may not be yet on the first client
 * render, so the event waits a few seconds for it and is then dropped rather than
 * thrown.
 */
export const onFSReady = (
	eventName: string,
	eventContext: Record<string, unknown>,
	waited = 0,
) => {
	if (typeof window === 'undefined') return;
	const fs = snippet();
	if (fs) {
		fs('trackEvent', { name: eventName, properties: eventContext });
		return;
	}
	if (waited < WAIT_MS) {
		window.setTimeout(
			() => onFSReady(eventName, eventContext, waited + POLL_MS),
			POLL_MS,
		);
	}
};
